module.exports = "<happy-input-template [controlName]=\"formControlName\" [form]=\"form\" [required]=\"required\">\n    <ng-content select=[input-label] input-label></ng-content>\n    <ng-content select=[input-guidance] input-guidance></ng-content>\n    <select class=\"form-control\" input-control ngDefaultControl>\n        <ng-content select=[input-options]></ng-content>\n    </select>\n</happy-input-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-select-input/happy-select-input.component.html
// module id = 963
// module chunks = 0